import React from 'react';
import { Box, Typography, Paper, Container, Grid } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';

const PictureLight: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Paper 
        elevation={3} 
        sx={{ 
          p: 3, 
          mt: 2, 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          PictureLight
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box 
              sx={{ 
                width: '100%', 
                height: '120px', 
                bgcolor: 'grey.200', 
                borderRadius: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <ImageIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box 
              sx={{ 
                width: '100%', 
                height: '120px', 
                bgcolor: 'grey.200', 
                borderRadius: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <ImageIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default PictureLight; 